import { Button, Col, Row, Typography, Skeleton, Space, Checkbox, Input, Select } from "antd";
import _filter from "lodash/filter";
import _find from "lodash/find";
import _times from "lodash/times";
import _isEmpty from "lodash/isEmpty";
import _isEqual from "lodash/isEqual";
import _map from "lodash/map";
import _mapKeys from "lodash/mapKeys";
import _range from "lodash/range";
import _get from "lodash/get";
import _forEach from "lodash/forEach";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";

import AppModal from "../../components/AppModal/AppModal";
import FilePreview from "../../components/FilePreview";
// import defaultImageFile from "../../images/defaultImageFile.svg";
import {
  BUILDING_TABS_KEYS,
  FORM_FIELDS_LOOKUP,
  FORM_FIELDS_TYPE,
  LAND_TABS_KEYS,
  LANGUAGE_CODES,
  MEDIA_TYPES,
  PROPERTY_TYPE_KEYS,
} from "../../utils/constants";
import { isImageFileType, isPDFFileType, toastMessage } from "../../utils/utils";
import CustomDroppable from "./CustomDroppable";
import "./PropertyMedia.scss";
import PDFIcon from "./PDFIcon";
import CustomTooltipHelper from "../../components/CustomTooltipHelper/CustomTooltipHelper";
import CustomFormItem from "../../components/CustomFormItem/CustomFormItem";
import MediaAssetService from "../../services/mediaAsset.service";
import {
  MEDIA_ASSET_FILE_TYPES,
  MEDIA_ASSET_PROPERTY_TYPES,
  DEFAULT_MEDIA_ASSET_SLOT_IDS,
  getMediaAssetPlaceholder,
  getMediaAssetTaxonomy,
  getSelectableMediaAssetTaxonomy,
  setMediaAssetTaxonomy,
} from "../../utils/mediaAssetsTaxonomy";

const { Text } = Typography;
const STATIC_MEDIA_SLOT_IDS = [
  "all",
  "propertyMarketingCollateral",
  "propertyBrochure",
  "sitePlan",
  "gallery",
  "aerial",
  "hero",
];

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const RANDOM = new Date().getTime();
/**
 * Moves an item from one list to another list.
 */
const move = ({ sourceList, destinationList, source, destination, draggableId, allList }) => {
  const sourceClone = [...sourceList];
  const destClone = [...destinationList];
  const allListClone = [];

  const result = {};

  const removed = sourceClone.find(d => d.asset_id === draggableId);
  let removedFromSource = [];
  if (![MEDIA_TYPES.GALLERY, MEDIA_TYPES.PROPERTY_MARKETING_COLLATERAL, "all"].includes(destination.droppableId)) {
    removedFromSource = destClone.splice(0, 1, removed);
    // sourceClone.push(...removedFromSource);
    // }  else if (destination.droppableId === MEDIA_TYPES.GALLERY) {
    // toastMessage(
    //   "error",
    //   "You can only add 10 Images in Gallery. Please Remove Image if you want to add more images to Gallery",
    //   { duration: 0 },
    // );
  } else destClone.push(removed);

  // If source & destination is not an All Media Section, then move the removed item to All Media Section
  if (![source.droppableId, source.droppableId].includes("all")) allListClone.push(...allList, ...removedFromSource);
  else sourceClone.push(...removedFromSource);

  const newSrcArr = sourceClone.filter(d => d.asset_id !== removed.asset_id);
  result[source.droppableId] = newSrcArr;
  result[destination.droppableId] = destClone;
  result.allList = allListClone;

  return result;
};

const getListStyle = (isDraggingOver, gallery) => ({
  background: isDraggingOver ? "lightblue" : "#fff" || "rgb(239 239 239)",
  overflow: "visible",
  display: "flex",
  flexWrap: "wrap",
  borderTop: "2px solid #e4e4e4",
  minHeight: gallery ? 320 : 495,
  // justifyContent: "space-evenly",
});

const getItemStyle = (isDragging, draggableStyle) => ({
  // change background colour if dragging
  background: isDragging ? "lightgreen" : "#FFF" || "rgb(239 239 239)",
  // styles we need to apply on draggables */
  userSelect: "text",
  ...draggableStyle,
});

const mapAllMedia = (selectedMedia = {}, propertyMedia, translatedSelectedMedia = {}) => {
  const selectedAssetIds = {};
  Object.keys(selectedMedia || {}).forEach(key => {
    if (Array.isArray(selectedMedia[key])) {
      Object.assign(selectedAssetIds, _mapKeys(selectedMedia[key], "asset_id"));
    }
  });
  const _translatedMedia = [];

  Object.keys(translatedSelectedMedia).forEach(item => {
    Object.keys(translatedSelectedMedia[item]?.media || {}).forEach(mediaKey => {
      _forEach(translatedSelectedMedia[item].media[mediaKey], _item => {
        if (_item?.asset_id) _translatedMedia.push(_item.asset_id);
      });
    });
  });

  return _filter(propertyMedia, i => !selectedAssetIds[i.asset_id] && _translatedMedia.indexOf(i.asset_id) === -1);
};

const getMainListStyle = isDraggingOver => ({
  background: isDraggingOver ? "lightblue" : "#fff" || "#f5f5f5",
  border: "1px #f5f5f5 solid",
  overflow: "auto",
  display: "flex",
  flexWrap: "wrap",
  alignContent: "flex-start",
  gap: "14px",
  padding: "10px",
  height: "665px",
});

const PlaceHolder = ({ loading, children, cols }) => {
  const _placeholders = [];
  _times(cols, i => {
    _placeholders.push(
      <Col span={8} key={i}>
        <Space className="w-full" direction="vertical" align="center">
          <Skeleton.Image />
          <Skeleton.Button active size="small" />
        </Space>
      </Col>,
    );
  });
  return loading ? <Row className="w-full mg-top-20">{_map(_placeholders)}</Row> : children;
};

export class PropertyMediaContainer extends Component {
  state = {
    all: [],
    propertyMarketingCollateral: [],
    propertyBrochure: [],
    sitePlan: [],
    gallery: [],
    aerial: [],
    hero: [],
    mediaAssetTaxonomy: getMediaAssetTaxonomy(this.props.isDynamicMediaAssetsEnabled),
    mediaAssetSlotIds: this.props.isDynamicMediaAssetsEnabled ? DEFAULT_MEDIA_ASSET_SLOT_IDS : [],
    translatedMedia: {},
    category: { image: false, pdf: false },
    isSectionDisabled: {
      all: false || this.props.viewOnlyMode,
      propertyMarketingCollateral: true,
      propertyBrochure: true,
      sitePlan: true,
      gallery: true,
      aerial: true,
      hero: true,
    },
    isModalOpen: false,
    previewItem: null,
    dragDisabledID: "",
    isCheckedSitePlanLang: false,
    isCheckedPropertyMarketingCollateralLang: false,
  };

  componentDidMount() {
    if (this.props.isDynamicMediaAssetsEnabled) this.fetchMediaAssetTaxonomy();
  }

  fetchMediaAssetTaxonomy = async () => {
    if (!this.props.isDynamicMediaAssetsEnabled) return;

    try {
      const response = await MediaAssetService.getAll();
      const mediaAssetTaxonomy = setMediaAssetTaxonomy(response || []);
      this.setState({ mediaAssetTaxonomy, mediaAssetSlotIds: this.getSelectedMediaAssetSlotIds() });
    } catch (ex) {
      this.setState({
        mediaAssetTaxonomy: getMediaAssetTaxonomy(),
        mediaAssetSlotIds: this.getSelectedMediaAssetSlotIds(),
      });
    }
  };

  getMediaAssetTypesForProperty = () => {
    if (!this.props.isDynamicMediaAssetsEnabled) return [];

    const propertyTypeName =
      this.props.propertyType === PROPERTY_TYPE_KEYS.land
        ? MEDIA_ASSET_PROPERTY_TYPES.land
        : MEDIA_ASSET_PROPERTY_TYPES.building;

    return getSelectableMediaAssetTaxonomy(this.state.mediaAssetTaxonomy).filter(asset =>
      asset.propertyTypes.includes(propertyTypeName),
    );
  };

  getMediaAssetTypeById = id => this.getMediaAssetTypesForProperty().find(asset => asset.id === id);

  getSelectedMediaAssetSlotIds = (selectedMedia = this.props.selectedMedia) => {
    const selectedSlotIds = Object.keys(selectedMedia || {}).filter(key => !STATIC_MEDIA_SLOT_IDS.includes(key));

    return [...new Set([...DEFAULT_MEDIA_ASSET_SLOT_IDS, ...selectedSlotIds])];
  };

  getVisibleMediaAssetTypes = () => {
    const mediaAssetTypeIds = this.getMediaAssetTypesForProperty().map(asset => asset.id);
    const visibleSlotIds = [...new Set([...this.state.mediaAssetSlotIds, ...mediaAssetTypeIds])];

    return visibleSlotIds.map(this.getMediaAssetTypeById).filter(Boolean);
  };

  getMediaAssetSlotResetState = () =>
    this.getMediaAssetTypesForProperty().reduce((result, asset) => ({ ...result, [asset.id]: [] }), {});

  onChangeMediaAssetSlot = (currentAssetId, nextAssetId) => {
    const visibleMediaAssetIds = this.getVisibleMediaAssetTypes().map(asset => asset.id);

    this.setState(
      state => {
        const mediaAssetSlotIds = visibleMediaAssetIds.map(assetId =>
          assetId === currentAssetId ? nextAssetId : assetId,
        );
        const movedMedia = state[currentAssetId] || [];

        return {
          mediaAssetSlotIds,
          [currentAssetId]: [],
          [nextAssetId]: movedMedia,
        };
      },
      () => {
        this.props.updateFiles(this.state, this.state.translatedMedia);
      },
    );
  };

  getSelectedMediaAssetIds = currentAssetId =>
    this.getVisibleMediaAssetTypes()
      .map(asset => asset.id)
      .filter(assetId => assetId !== currentAssetId);

  renderMediaAssetSlot = asset => {
    const { viewOnlyMode } = this.props;
    const options = this.getMediaAssetTypesForProperty();
    const selectedAssetIds = this.getSelectedMediaAssetIds(asset.id);
    const availableOptions = options.filter(option => option.id === asset.id || !selectedAssetIds.includes(option.id));

    return (
      <Col span={8} xs={24} sm={12} lg={8} key={asset.id}>
        <div className="media-asset-droppable-container">
          <div>
            <h5>{this.props.t("PropertyMedia.MediaType")}</h5>
            <Select
              className="media-asset-type-select"
              value={asset.id}
              disabled={viewOnlyMode}
              onChange={value => this.onChangeMediaAssetSlot(asset.id, value)}
            >
              {availableOptions.map(option => (
                <Select.Option value={option.id} key={option.id}>
                  {option.name}
                </Select.Option>
              ))}
            </Select>
          </div>
          <CustomDroppable
            className="mg-left-8 mg-right-8 mg-bottom-8"
            list={this.state[asset.id] || []}
            isDropDisabled={this.state.isSectionDisabled[asset.id]}
            type={asset.id}
            fileType={asset.fileTypes}
            previewFile={this.previewFile}
            placeholderText={getMediaAssetPlaceholder(asset)}
            isDragDisabled={viewOnlyMode}
            altLabel={asset.fileTypes.includes(MEDIA_ASSET_FILE_TYPES.image) ? "Image Description" : ""}
          />
        </div>
      </Col>
    );
  };

  componentDidUpdate(prevProps) {
    const { propertyMedia, selectedMedia, selectedPropertyCode, translatedSelectedMedia } = this.props;

    let newState = {};

    if (this.props.isEditView) {
      /* --- EDIT --- */
      if (
        !_isEqual(prevProps.propertyMedia, propertyMedia) ||
        !_isEqual(prevProps.selectedMedia, selectedMedia) ||
        !_isEqual(prevProps.translatedSelectedMedia, translatedSelectedMedia)
      ) {
        newState.all = mapAllMedia(selectedMedia, propertyMedia, translatedSelectedMedia);
        newState = {
          ...newState,
          ...this.getMediaAssetSlotResetState(),
          ...selectedMedia,
          mediaAssetSlotIds: this.getSelectedMediaAssetSlotIds(selectedMedia),
          translatedMedia: translatedSelectedMedia,
        };

        if (!_isEmpty(selectedMedia) && !_isEmpty(translatedSelectedMedia)) {
          Object.keys(translatedSelectedMedia).forEach(item => {
            if (
              !_isEmpty(selectedMedia.sitePlan) &&
              !_isEmpty(translatedSelectedMedia[item]?.media?.sitePlan) &&
              selectedMedia?.sitePlan[0]?.asset_id === translatedSelectedMedia[item]?.media?.sitePlan[0]?.asset_id
            ) {
              newState.isCheckedSitePlanLang = true;
            }
            if (
              !_isEmpty(selectedMedia.propertyMarketingCollateral) &&
              !_isEmpty(translatedSelectedMedia[item]?.media?.propertyMarketingCollateral) &&
              selectedMedia?.propertyMarketingCollateral[0]?.asset_id ===
                translatedSelectedMedia[item]?.media?.propertyMarketingCollateral[0]?.asset_id
            ) {
              newState.isCheckedPropertyMarketingCollateralLang = true;
            }
          });
        }
      }
    } else if (
      !_isEqual(prevProps.selectedPropertyCode, selectedPropertyCode) ||
      !_isEqual(prevProps.propertyMedia, propertyMedia) /*  && !_isEmpty(this.props.selectedMedia) */
    ) {
      /* --- ADD --- */
      // if (!_isEqual(this.props.selectedPropertyCode, selectedPropertyCode)) {
      //   // Clear Selected Media
      //   newState.all = mapAllMedia({}, propertyMedia);
      // }

      // if (!_isEqual(this.props.selectedMedia, selectedMedia)) {
      //   newState = { ...newState, selectedMedia };
      // }

      // if (
      //   !_isEqual(this.props.selectedPropertyCode, selectedPropertyCode) ||
      //   !_isEqual(this.props.propertyMedia, propertyMedia) /*  && !_isEmpty(this.props.selectedMedia) */
      // ) {
      // Clear Selected Media
      newState.all = mapAllMedia({}, propertyMedia, {});
      newState.hero = [];
      newState.aerial = [];
      newState.gallery = [];
      newState.sitePlan = [];
      newState.propertyBrochure = [];
      newState.propertyMarketingCollateral = [];
      newState.translatedMedia = {};
      newState.mediaAssetSlotIds = this.getSelectedMediaAssetSlotIds({});
      newState = { ...newState, ...this.getMediaAssetSlotResetState() };
      // }
    }
    // eslint-disable-next-line react/no-did-update-set-state
    if (!_isEmpty(newState)) this.setState(newState);
  }

  /**
   * A semi-generic way to handle multiple lists. Matches
   * the IDs of the all container to the names of the
   * source arrays stored in the state.
   */
  id2List = {
    all: "all",
    propertyMarketingCollateral: "propertyMarketingCollateral",
    propertyBrochure: "propertyBrochure",
    sitePlan: "sitePlan",
    gallery: "gallery",
    aerial: "aerial",
    hero: "hero",
  };

  getList = id => this.state[this.id2List[id] || id] || [];

  updateTranslatedMediaFields = (items, key, sourceKey) => {
    const { language } = this.props;
    const { isCheckedSitePlanLang, isCheckedPropertyMarketingCollateralLang } = this.state;
    const isEnglish = language.current === LANGUAGE_CODES.English.value;
    let _state = {};

    if (isEnglish) {
      _state = {
        [key]: items,
      };
      if ((isCheckedSitePlanLang || isCheckedPropertyMarketingCollateralLang) && !_isEmpty(language.secondary)) {
        if (isCheckedSitePlanLang && key === "sitePlan") {
          // _state = {
          //   ..._state,
          //   translatedMedia: {
          //     ...this.state.translatedMedia,
          //     [language.secondary]: {
          //       media: {
          //         ..._get(this.state, `translatedMedia.${language.secondary}.media`),
          //         [key]: items,
          //       },
          //     },
          //   }
          // };
          _forEach(language.secondary, _language => {
            _state = {
              ..._state,
              translatedMedia: {
                ...this.state.translatedMedia,
                ..._get(_state, "translatedMedia"),
                [_language]: {
                  media: {
                    ..._get(this.state, `translatedMedia.${_language}.media`),
                    ..._get(_state, `translatedMedia.${_language}.media`),
                    [key]: items,
                  },
                },
              },
            };
          });
        } else if (isCheckedPropertyMarketingCollateralLang && key === "propertyMarketingCollateral") {
          // _state = {
          //   ..._state,
          //   translatedMedia: {
          //     ...this.state.translatedMedia,
          //     [language.secondary]: {
          //       media: {
          //         ..._get(this.state, `translatedMedia.${language.secondary}.media`),
          //         [key]: items,
          //       },
          //     },
          //   },
          // };
          _forEach(language.secondary, _language => {
            _state = {
              ..._state,
              translatedMedia: {
                ...this.state.translatedMedia,
                ..._get(_state, "translatedMedia"),
                [_language]: {
                  media: {
                    ..._get(this.state, `translatedMedia.${_language}.media`),
                    ..._get(_state, `translatedMedia.${_language}.media`),
                    [key]: items,
                  },
                },
              },
            };
          });
        }

        if (sourceKey === "propertyMarketingCollateral" && isCheckedPropertyMarketingCollateralLang) {
          // _state = {
          //   ..._state,
          //   translatedMedia: {
          //     ..._state.translatedMedia,
          //     [language.secondary]: {
          //       media: {
          //         ..._get(this.state, `translatedMedia.${language.secondary}.media`),
          //         ..._get(_state, `translatedMedia.${language.secondary}.media`),
          //         [sourceKey]: [],
          //       },
          //     },
          //   },
          // };
          _forEach(language.secondary, _langauge => {
            _state = {
              ..._state,
              translatedMedia: {
                ..._state.translatedMedia,
                [_langauge]: {
                  media: {
                    ..._get(this.state, `translatedMedia.${_langauge}.media`),
                    ..._get(_state, `translatedMedia.${_langauge}.media`),
                    [sourceKey]: [],
                  },
                },
              },
            };
          });
        } else if (sourceKey === "sitePlan" && isCheckedSitePlanLang) {
          // _state = {
          //   ..._state,
          //   translatedMedia: {
          //     ..._state.translatedMedia,
          //     [language.secondary]: {
          //       media: {
          //         ..._get(this.state, `translatedMedia.${language.secondary}.media`),
          //         ..._get(_state, `translatedMedia.${language.secondary}.media`),
          //         [sourceKey]: [],
          //       },
          //     },
          //   },
          // };
          _forEach(language.secondary, _langauge => {
            _state = {
              ..._state,
              translatedMedia: {
                ..._state.translatedMedia,
                [_langauge]: {
                  media: {
                    ..._get(this.state, `translatedMedia.${_langauge}.media`),
                    ..._get(_state, `translatedMedia.${_langauge}.media`),
                    [sourceKey]: [],
                  },
                },
              },
            };
          });
        }

        if (sourceKey === "propertyMarketingCollateral") {
          _state = {
            ..._state,
            isCheckedPropertyMarketingCollateralLang: false,
          };
        } else if (sourceKey === "sitePlan") {
          _state = {
            ..._state,
            isCheckedSitePlanLang: false,
          };
        }
      }
    } else {
      _state = {
        translatedMedia: {
          ...this.state.translatedMedia,
          [language.current]: {
            media: {
              ..._get(this.state, `translatedMedia[${language.current}].media`),
              [sourceKey]: [],
              [key]: items,
            },
          },
        },
      };
    }

    return _state;
  };

  onDragEnd = result => {
    const { source, destination, draggableId } = result;
    // dropped outside the list
    if (!destination) {
      return;
    }

    if (source.droppableId === destination.droppableId) {
      const items = reorder(this.getMedia(source.droppableId), source.index, destination.index);

      let state = { all: items };

      if (source.droppableId === MEDIA_TYPES.PROPERTY_MARKETING_COLLATERAL) {
        // state = { propertyMarketingCollateral: items };
        state = this.updateTranslatedMediaFields(items, "propertyMarketingCollateral");
      } else if (source.droppableId === MEDIA_TYPES.SITE_PLAN) {
        // state = { sitePlan: items };
        state = this.updateTranslatedMediaFields(items, "sitePlan");
      } else if (source.droppableId === MEDIA_TYPES.GALLERY) {
        state = { gallery: items };
      } else if (source.droppableId === MEDIA_TYPES.PROPERTY_BROCHURE) {
        state = { propertyBrochure: items };
      } else if (source.droppableId === MEDIA_TYPES.AERIAL) {
        state = { aerial: items };
      } else if (source.droppableId === MEDIA_TYPES.HERO) {
        state = { hero: items };
      } else if (source.droppableId !== "all") {
        state = { [source.droppableId]: items };
      }
      this.setState(state);
    } else if (
      destination.droppableId === MEDIA_TYPES.GALLERY &&
      this.getMedia(destination.droppableId).length === 10
    ) {
      toastMessage(
        "error",
        "You can only add 10 Images in Gallery. Please Remove Image if you want to add more images to Gallery",
        null,
        { duration: 0 },
      );
    } else {
      const resultState = move({
        sourceList: this.getMedia(source.droppableId),
        destinationList: this.getMedia(destination.droppableId),
        source,
        destination,
        draggableId,
        allList: this.getMedia("all"),
      });

      let state = {};
      if (resultState.propertyMarketingCollateral) {
        // state = { ...state, propertyMarketingCollateral: resultState.propertyMarketingCollateral };
        state = {
          ...state,
          ...this.updateTranslatedMediaFields(
            resultState.propertyMarketingCollateral,
            "propertyMarketingCollateral",
            source.droppableId,
          ),
        };
      }
      if (resultState.sitePlan) {
        // state = { ...state, sitePlan: resultState.sitePlan };
        state = { ...state, ...this.updateTranslatedMediaFields(resultState.sitePlan, "sitePlan", source.droppableId) };
      }
      if (resultState.gallery) {
        state = { ...state, gallery: resultState.gallery };
      }
      if (resultState.propertyBrochure) {
        state = { ...state, propertyBrochure: resultState.propertyBrochure };
      }
      if (resultState.aerial) {
        state = { ...state, aerial: resultState.aerial };
      }
      if (resultState.hero) {
        state = { ...state, hero: resultState.hero };
      }
      Object.keys(resultState).forEach(key => {
        if (
          ![
            "all",
            "allList",
            "propertyMarketingCollateral",
            "sitePlan",
            "gallery",
            "propertyBrochure",
            "aerial",
            "hero",
          ].includes(key)
        ) {
          state = { ...state, [key]: resultState[key] };
        }
      });
      if (resultState.all || resultState.allList) {
        state = { ...state, all: resultState.all || resultState.allList };
      }

      this.setState(state, () => {
        this.props.updateFiles(this.state, this.state.translatedMedia);
      });
    }
  };

  onDragStart = ({ source, draggableId }) => {
    const { language } = this.props;
    this.setState(({ category, isSectionDisabled, ...rs }) => {
      isSectionDisabled.hero = true;
      isSectionDisabled.aerial = true;
      isSectionDisabled.gallery = true;
      isSectionDisabled.sitePlan = true;
      isSectionDisabled.propertyMarketingCollateral = true;
      isSectionDisabled.propertyBrochure = true;
      this.getMediaAssetTypesForProperty().forEach(asset => {
        isSectionDisabled[asset.id] = true;
      });

      const mediaSource =
        language.current === LANGUAGE_CODES.English.value ||
        (source.droppableId !== MEDIA_TYPES.SITE_PLAN &&
          source.droppableId !== MEDIA_TYPES.PROPERTY_MARKETING_COLLATERAL)
          ? rs[source.droppableId]
          : _get(rs, `translatedMedia.${language.current}.media.${source.droppableId}`);

      const draggedItem = _find(mediaSource || rs.all, { asset_id: draggableId }) || {};
      // const draggedItem = _find(_get(rs, `translatedMedia.${language.current}.media.${source.droppableId}`) || rs.all, { asset_id: draggableId }) || {};

      if (draggedItem.thumbnails_webimage_url && isImageFileType(draggedItem || draggedItem.thumbnails_webimage_url)) {
        isSectionDisabled.hero = false;
        isSectionDisabled.aerial = false;
        isSectionDisabled.gallery = false;
        isSectionDisabled.sitePlan = false;
        isSectionDisabled.propertyBrochure = false;
        this.getMediaAssetTypesForProperty().forEach(asset => {
          if (asset.fileTypes.includes(MEDIA_ASSET_FILE_TYPES.image)) isSectionDisabled[asset.id] = false;
        });
      }
      if (draggedItem.thumbnails_webimage_url && isPDFFileType(draggedItem || draggedItem.thumbnails_webimage_url)) {
        isSectionDisabled.sitePlan = false;
        isSectionDisabled.propertyMarketingCollateral = false;
        isSectionDisabled.propertyBrochure = false;
        this.getMediaAssetTypesForProperty().forEach(asset => {
          if (asset.fileTypes.includes(MEDIA_ASSET_FILE_TYPES.pdf)) isSectionDisabled[asset.id] = false;
        });
      }

      if (source.droppableId === MEDIA_TYPES.HERO) {
        isSectionDisabled.hero = true;
      }
      if (
        [MEDIA_TYPES.HERO, MEDIA_TYPES.AERIAL, MEDIA_TYPES.GALLERY, MEDIA_TYPES.SITE_PLAN].includes(
          source.droppableId,
        ) &&
        isImageFileType(draggedItem || draggedItem.thumbnails_webimage_url)
      ) {
        isSectionDisabled.hero = false;
        isSectionDisabled.aerial = false;
        isSectionDisabled.gallery = false;
        isSectionDisabled.sitePlan = false;
        isSectionDisabled.propertyBrochure = false;
        this.getMediaAssetTypesForProperty().forEach(asset => {
          if (asset.fileTypes.includes(MEDIA_ASSET_FILE_TYPES.image)) isSectionDisabled[asset.id] = false;
        });
      }
      if (
        [MEDIA_TYPES.SITE_PLAN, MEDIA_TYPES.PROPERTY_MARKETING_COLLATERAL, MEDIA_TYPES.PROPERTY_BROCHURE].includes(
          source.droppableId,
        ) &&
        isPDFFileType(draggedItem || draggedItem.thumbnails_webimage_url)
      ) {
        isSectionDisabled.sitePlan = false;
        isSectionDisabled.propertyMarketingCollateral = false;
        isSectionDisabled.propertyBrochure = false;
        this.getMediaAssetTypesForProperty().forEach(asset => {
          if (asset.fileTypes.includes(MEDIA_ASSET_FILE_TYPES.pdf)) isSectionDisabled[asset.id] = false;
        });
      }
      // if (source.droppableId === MEDIA_TYPES.AERIAL) {
      //   isSectionDisabled.aerial = true;
      // }
      // if (source.droppableId === MEDIA_TYPES.GALLERY) {
      //   isSectionDisabled.gallery = true;
      // }
      // if (source.droppableId === MEDIA_TYPES.SITE_PLAN) {
      //   isSectionDisabled.sitePlan = true;
      // }
      // if (source.droppableId === MEDIA_TYPES.PROPERTY_MARKETING_COLLATERAL) {
      //   isSectionDisabled.propertyMarketingCollateral = true;
      // }
      if (source.droppableId === "all") {
        isSectionDisabled.all = false;
      }
      return { isSectionDisabled };
    });
  };

  onChangeCategory = key => {
    this.setState(({ category }) => ({ category: { ...category, [key]: !category[key] } }));
  };

  toggleModal = modalState => {
    this.setState({ isModalOpen: modalState });
  };

  previewFile = item => {
    this.toggleModal(true);
    this.setState({ previewItem: item });
  };

  _renderMessage = () => {
    // const { t } = useTranslation();
    const { t } = this.props;
    const showMessage =
      _isEmpty(this.state.all) &&
      _isEmpty(this.state.aerial) &&
      _isEmpty(this.state.gallery) &&
      _isEmpty(this.state.hero) &&
      _isEmpty(this.state.propertyBrochure) &&
      _isEmpty(this.state.propertyMarketingCollateral) &&
      _isEmpty(this.state.sitePlan);

    return (
      showMessage && (
        <Text type="secondary" className="helper-text">
          {this.props.selectedPropertyCode ? t("PropertyMedia.Message1") : t("PropertyMedia.Message2")}
        </Text>
      )
    );
  };

  setDragDisabledID = param => {
    this.setState({ dragDisabledID: param });
  };

  getMedia = key => {
    const { language } = this.props;
    const isEnglish = language.current === LANGUAGE_CODES.English.value;

    if ((key === MEDIA_TYPES.PROPERTY_MARKETING_COLLATERAL || key === MEDIA_TYPES.SITE_PLAN) && !isEnglish) {
      const translatedFile = _get(this.state, `translatedMedia.${language.current}.media.${key}`, []);

      return translatedFile;
    }
    return this.state[key] || [];
  };

  _onChangeCheckbox = (event, key) => {
    const { checked } = event.target;
    const { language, selectedMedia, translatedSelectedMedia, propertyMedia } = this.props;
    const { secondary } = language;
    const checkedKey = key === "sitePlan" ? "isCheckedSitePlanLang" : "isCheckedPropertyMarketingCollateralLang";

    if (checked) {
      this.setState(
        prevState => {
          // {
          //   translatedMedia: {
          //     [secondary]: {
          //       media: {
          //         ..._get(prevState, `translatedMedia.${secondary}.media`, {}),
          //         [key]: prevState[key],
          //       },
          //     },
          //   },
          //   [checkedKey]: checked,
          // }
          let _state = { [checkedKey]: checked };

          secondary.forEach(_langauge => {
            _state = {
              ..._state,
              translatedMedia: {
                ..._state.translatedMedia,
                [_langauge]: {
                  media: {
                    ..._get(prevState, `translatedMedia.${_langauge}.media`, {}),
                    [key]: prevState[key],
                  },
                },
              },
            };
          });

          return _state;
        },
        () => {
          this.setState({
            all: mapAllMedia(selectedMedia, propertyMedia, translatedSelectedMedia),
          });
          this.props.updateFiles(this.state, this.state.translatedMedia);
        },
      );
    } else {
      this.setState(
        prevState => {
          // {
          //   translatedMedia: {
          //     [secondary]: {
          //       media: {
          //         ..._get(prevState, `translatedMedia.${secondary}.media`, {}),
          //         [key]: [],
          //       },
          //     },
          //   },
          //   [checkedKey]: checked,
          // }
          let _state = { [checkedKey]: checked };
          secondary.forEach(_langauge => {
            _state = {
              ..._state,
              translatedMedia: {
                [_langauge]: {
                  media: {
                    ..._get(prevState, `translatedMedia.${_langauge}.media`, {}),
                    [key]: [],
                  },
                },
              },
            };
          });
          return _state;
        },
        () => {
          this.setState({
            all: mapAllMedia(selectedMedia, propertyMedia, translatedSelectedMedia),
          });
          this.props.updateFiles(this.state, this.state.translatedMedia);
        },
      );
    }
  };

  render() {
    const { t, language, languageStatus, form, auditPanelDrawerVisible, propertyType } = this.props;
    const { dragDisabledID, isCheckedSitePlanLang, isCheckedPropertyMarketingCollateralLang } = this.state;
    const { viewOnlyMode, helperText } = this.props;
    const filteredImages = _filter(this.state.all, i => {
      if (!this.state.category.image && !this.state.category.pdf) return true;
      if (this.state.category.image && isImageFileType(i || i.thumbnails_webimage_url)) return true;
      if (this.state.category.pdf && isPDFFileType(i || i.thumbnails_webimage_url)) return true;
      return false;
    });

    const fieldsType = FORM_FIELDS_TYPE.regular;

    const _tabsKey = propertyType === PROPERTY_TYPE_KEYS.land ? LAND_TABS_KEYS : BUILDING_TABS_KEYS;
    const _fieldName =
      propertyType === PROPERTY_TYPE_KEYS.land ? FORM_FIELDS_LOOKUP.land.media : FORM_FIELDS_LOOKUP.building.media;

    return (
      <>
        <h2>{t("PropertyMedia.MediaContent")}</h2>
        <p>{t("PropertyMedia.Description1")}</p>
        <p>{t("PropertyMedia.Description2")}</p>
        <p>
          {t("PropertyMedia.Description3")}
          <a href="https://prologis.box.com/s/ujose16zohhxqbanagvlucqnwg4gkwyj" target="_blank">
            {t("PropertyMedia.LinkHere")}
          </a>
          {t("PropertyMedia.Description4")}
        </p>
        <DragDropContext onDragEnd={this.onDragEnd} onDragStart={this.onDragStart}>
          <Row className="fields-row" gutter={[16, 16]} type="flex">
            <Col xs={24} sm={24} md={24} lg={14}>
              <Row className="fields-row row-vertical-padding-8" gutter={[16, 24]} type="flex">
                <Col span={6} xs={24} sm={12} lg={6}>
                  <div className="droppable-container">
                    <div>
                      <h5 className={fieldsType === FORM_FIELDS_TYPE.regular ? "required" : ""}>
                        <CustomTooltipHelper
                          label={t("PropertyMedia.Hero")}
                          tooltip={helperText.hero}
                          form={form}
                          tab={_tabsKey[4]}
                          fieldName={_fieldName.hero.key}
                          auditPanelDrawerVisible={auditPanelDrawerVisible}
                        />
                        {/* {!_isEmpty(helperText.hero) && (
                          <Tooltip title={getDangerouslySetHTML(getTranslatedHelperText(helperText.hero, language))}>
                            <CustomIcon name="InfoCircleOutlined" />
                          </Tooltip>
                        )} */}
                      </h5>
                      <h6 className="lable-with-margin">{t("PropertyMedia.ImageOnly")}</h6>
                    </div>
                    <CustomDroppable
                      className="mg-left-8 mg-right-8 mg-bottom-8"
                      list={this.state.hero}
                      isDropDisabled={this.state.isSectionDisabled.hero}
                      type={MEDIA_TYPES.HERO}
                      fileType="image"
                      previewFile={this.previewFile}
                      placeholderText={t("PropertyMedia.Placeholder")}
                      isDragDisabled={viewOnlyMode}
                      altLabel={t("PropertyMedia.altLabel")}
                    />
                  </div>
                  {this.props.mediaErrors.hero && (
                    <div className="ant-form-item-has-error ">
                      <div className="ant-form-item-explain ant-form-item-explain-error text-center">
                        {t("PropertyMedia.HeroImage")}
                      </div>
                    </div>
                  )}
                </Col>
                <Col span={6} xs={24} sm={12} lg={6}>
                  <div className="droppable-container">
                    <div>
                      <h5>
                        <CustomTooltipHelper
                          label={t("PropertyMedia.Aerial")}
                          tooltip={helperText.aerial}
                          form={form}
                          tab={_tabsKey[4]}
                          fieldName={_fieldName.aerial.key}
                          auditPanelDrawerVisible={auditPanelDrawerVisible}
                        />
                        {/* {!_isEmpty(helperText.aerial) && (
                          <Tooltip title={getDangerouslySetHTML(getTranslatedHelperText(helperText.aerial, language))}>
                            <CustomIcon name="InfoCircleOutlined" />
                          </Tooltip>
                        )} */}
                      </h5>
                      <h6 className="lable-with-margin">{t("PropertyMedia.ImageOnly")}</h6>
                    </div>

                    <CustomDroppable
                      className="mg-left-8 mg-right-8 mg-bottom-8"
                      list={this.state.aerial}
                      isDropDisabled={this.state.isSectionDisabled.aerial}
                      type={MEDIA_TYPES.AERIAL}
                      fileType="image"
                      previewFile={this.previewFile}
                      placeholderText={t("PropertyMedia.Placeholder")}
                      isDragDisabled={viewOnlyMode}
                      altLabel={t("PropertyMedia.altLabel")}
                    />
                  </div>
                </Col>
                <Col span={6} xs={24} sm={12} lg={6}>
                  <div className="droppable-container">
                    <div>
                      <h5>{t("PropertyMedia.PropertyBrochure")}</h5>
                      <h6 className="lable-with-margin">{t("PropertyMedia.ImageorPdf")}</h6>
                    </div>
                    <CustomDroppable
                      className="mg-left-8 mg-right-8 mg-bottom-8"
                      list={this.state.propertyBrochure}
                      isDropDisabled={this.state.isSectionDisabled.propertyBrochure}
                      type={MEDIA_TYPES.PROPERTY_BROCHURE}
                      fileType={["image", "pdf"]}
                      previewFile={this.previewFile}
                      placeholderText={t("PropertyMedia.Placeholder2")}
                      isDragDisabled={viewOnlyMode}
                      altLabel={t("PropertyMedia.altLabel")}
                    />
                  </div>
                </Col>
                <Col span={6} xs={24} sm={12} lg={6}>
                  <div className="droppable-container">
                    <div>
                      <h5>
                        <CustomTooltipHelper
                          label={t("PropertyMedia.SitePlan")}
                          tooltip={helperText.sitePlan}
                          form={form}
                          tab={_tabsKey[4]}
                          fieldName={_fieldName.sitePlan.key}
                          auditPanelDrawerVisible={auditPanelDrawerVisible}
                        />
                        {/* {!_isEmpty(helperText.sitePlan) && (
                          <Tooltip
                            title={getDangerouslySetHTML(getTranslatedHelperText(helperText.sitePlan, language))}
                          >
                            <CustomIcon name="InfoCircleOutlined" />
                          </Tooltip>
                        )} */}
                      </h5>
                      <h6 className={`${!_isEmpty(language.secondary) ? "" : "lable-with-margin"}`}>
                        {t("PropertyMedia.ImageorPdf")}
                      </h6>
                      {!_isEmpty(language.secondary) && (
                        <Checkbox
                          onChange={event => this._onChangeCheckbox(event, "sitePlan")}
                          className="media-langauge-checkbox"
                          disabled={
                            viewOnlyMode ||
                            language.current !== LANGUAGE_CODES.English.value ||
                            _isEmpty(this.state.sitePlan)
                          }
                          checked={isCheckedSitePlanLang}
                        >
                          {t("PropertyMedia.ApplyForAllLanguages")}
                        </Checkbox>
                      )}
                    </div>
                    <CustomDroppable
                      className="mg-left-8 mg-right-8 mg-bottom-8"
                      // list={this.state.sitePlan}
                      list={this.getMedia("sitePlan")}
                      isDropDisabled={
                        this.state.isSectionDisabled.sitePlan ||
                        (language.current !== LANGUAGE_CODES.English.value && isCheckedSitePlanLang)
                      }
                      type={MEDIA_TYPES.SITE_PLAN}
                      fileType="pdf"
                      previewFile={this.previewFile}
                      placeholderText={t("PropertyMedia.Placeholder2")}
                      isDragDisabled={
                        viewOnlyMode || (language.current !== LANGUAGE_CODES.English.value && isCheckedSitePlanLang)
                      }
                      altLabel={t("PropertyMedia.altLabel")}
                    />
                  </div>
                  {this.props.mediaErrors.sitePlan && (
                    <div className="ant-form-item-has-error ">
                      <div className="ant-form-item-explain ant-form-item-explain-error text-center">
                        {t("ErrorMessages.SelectBothTranslatedAndLocal")}
                      </div>
                    </div>
                  )}
                </Col>
                <Col span={6} xs={24} sm={12} lg={6}>
                  <div className="droppable-container">
                    <div>
                      <h5>
                        <CustomTooltipHelper
                          label={this.props.marketingCollateralLabel}
                          tooltip={helperText.marketingCollateral}
                          form={form}
                          tab={_tabsKey[4]}
                          fieldName={_fieldName.propertyMarketingCollateral.key}
                          auditPanelDrawerVisible={auditPanelDrawerVisible}
                        />
                        {/* {!_isEmpty(helperText.marketingCollateral) && (
                          <Tooltip
                            title={getDangerouslySetHTML(
                              getTranslatedHelperText(helperText.marketingCollateral, language),
                            )}
                          >
                            <CustomIcon name="InfoCircleOutlined" />
                          </Tooltip>
                        )} */}
                        &nbsp;
                      </h5>
                      <h6 className={`${!_isEmpty(language.secondary) ? "" : "lable-with-margin"}`}>
                        {t("PropertyMedia.PdfOnly")}
                      </h6>
                      {!_isEmpty(language.secondary) && (
                        <Checkbox
                          onChange={event => this._onChangeCheckbox(event, "propertyMarketingCollateral")}
                          className="media-langauge-checkbox"
                          disabled={
                            viewOnlyMode ||
                            language.current !== LANGUAGE_CODES.English.value ||
                            _isEmpty(this.state.propertyMarketingCollateral)
                          }
                          checked={isCheckedPropertyMarketingCollateralLang}
                        >
                          Apply for all languages
                        </Checkbox>
                      )}
                    </div>
                    <CustomDroppable
                      className="mg-left-8 mg-right-8 mg-bottom-8"
                      // list={this.state.propertyMarketingCollateral}
                      list={this.getMedia("propertyMarketingCollateral")}
                      isDropDisabled={
                        this.state.isSectionDisabled.propertyMarketingCollateral ||
                        (language.current !== LANGUAGE_CODES.English.value && isCheckedPropertyMarketingCollateralLang)
                      }
                      type={MEDIA_TYPES.PROPERTY_MARKETING_COLLATERAL}
                      fileType="pdf"
                      previewFile={this.previewFile}
                      placeholderText={t("PropertyMedia.Placeholder3")}
                      isDragDisabled={
                        viewOnlyMode ||
                        (language.current !== LANGUAGE_CODES.English.value && isCheckedPropertyMarketingCollateralLang)
                      }
                      altLabel={t("PropertyMedia.altLabel")}
                    />
                  </div>
                  {this.props.mediaErrors.propertyMarketingCollateral && (
                    <div className="ant-form-item-has-error ">
                      <div className="ant-form-item-explain ant-form-item-explain-error text-center">
                        {t("ErrorMessages.SelectBothTranslatedAndLocal")}
                      </div>
                    </div>
                  )}
                </Col>
              </Row>
              <Row className="fields-row row-vertical-padding-8" gutter={[16, 24]} type="flex">
                {this.getVisibleMediaAssetTypes().map(this.renderMediaAssetSlot)}
              </Row>
              <Row className="fields-row row-vertical-padding-8" gutter={[16, 24]} type="flex">
                {this.getVisibleMediaAssetTypes().map(this.renderMediaAssetSlot)}
              </Row>
              <Row className="fields-row row-vertical-padding-8" gutter={[16]} type="flex">
                <Col xs={24} sm={24} lg={8}>
                  <div className="other-media-assets-container">
                    <h5>{t("PropertyMedia.OtherMediaAssets")}</h5>
                    {[
                      ["digitalTourUrl", "Digital Tour URL", "DigitalTourUrlRulesMessage"],
                      ["videoUrl", "Video URL", "VideoUrlRulesMessage"],
                      ["micrositeUrl", "Microsite URL", "MicrositeUrlRulesMessage"],
                    ].map(([field, label, messageKey]) => (
                      <CustomFormItem
                        key={field}
                        label={label}
                        name={[propertyType === PROPERTY_TYPE_KEYS.land ? "landInfo" : "buildingInfo", field]}
                        rules={[
                          {
                            type: "url",
                            message: t(
                              `${propertyType === PROPERTY_TYPE_KEYS.land ? "LandInfo" : "BuildingInfo"}.${messageKey}`,
                            ),
                          },
                        ]}
                      >
                        <Input placeholder={label} disabled={viewOnlyMode} />
                      </CustomFormItem>
                    ))}
                  </div>
                </Col>
                <Col xs={24} sm={24} lg={16}>
                  <div className="droppable-container">
                    <div>
                      <h5>
                        <CustomTooltipHelper
                          label={t("PropertyMedia.ImageGallery")}
                          tooltip={helperText.imageGallery}
                          form={form}
                          tab={_tabsKey[4]}
                          fieldName={_fieldName.gallery.key}
                          auditPanelDrawerVisible={auditPanelDrawerVisible}
                        />
                        {/* {!_isEmpty(helperText.imageGallery) && (
                          <Tooltip
                            title={getDangerouslySetHTML(getTranslatedHelperText(helperText.imageGallery, language))}
                          >
                            <CustomIcon name="InfoCircleOutlined" />
                          </Tooltip>
                        )} */}
                      </h5>
                      <h6>{t("PropertyMedia.UpToTenImages")}</h6>
                    </div>
                    {/* ------------------------------ */}
                    <div className="property-media-gallery__container">
                      <Droppable
                        droppableId={MEDIA_TYPES.GALLERY}
                        direction="horizontal"
                        isDropDisabled={this.state.isSectionDisabled.gallery}
                      >
                        {(provided1, snapshot1) => (
                          <div
                            ref={provided1.innerRef}
                            className={`property-media-gallery__dropzone ${
                              _isEmpty(this.state.gallery)
                                ? "property-media-gallery__dropzone--empty"
                                : "property-media-gallery__dropzone--filled"
                            }`}
                            style={{
                              ...getListStyle(snapshot1.isDraggingOver, _isEmpty(this.state.gallery)),
                            }}
                          >
                            {_map(_range(10), index => {
                              const item = this.state.gallery[index];
                              if (!item) {
                                return (
                                  <div
                                    key={`${MEDIA_TYPES.GALLERY}-${index}`}
                                    className="property-media-gallery__item property-media-gallery__placeholder placeholder"
                                    style={{
                                      ...getItemStyle(false, {}),
                                      background: "#efefef",
                                      border: "2px solid #e4e4e4",
                                    }}
                                  >
                                    <div
                                      style={{
                                        justifyContent: "center",
                                        alignItems: "center",
                                        display: "flex",
                                        flexDirection: "column",
                                        height: "100%",
                                        fontSize: "12px",
                                      }}
                                    >
                                      <div className="text-center" style={{}}>
                                        {t("PropertyMedia.SelectanImage")}
                                      </div>
                                      <div className="text-center">
                                        <Button type="primary" shape="circle" size="small">
                                          {index + 1}
                                        </Button>
                                      </div>
                                    </div>
                                  </div>
                                );
                              }

                              const _url = `${item.thumbnails_webimage_url}?ver=${RANDOM}`;
                              const _alt = item.name;

                              return (
                                <Draggable
                                  key={item.asset_id}
                                  draggableId={item.asset_id}
                                  index={index}
                                  isDragDisabled={viewOnlyMode || dragDisabledID === item.asset_id}
                                >
                                  {(provided, snapshot) => (
                                    <div className="property-media-gallery__item">
                                      <div
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        style={{
                                          ...getItemStyle(snapshot.isDragging, provided.draggableProps.style),
                                        }}
                                      >
                                        <div
                                          className="property-media-gallery__item-hover"
                                          onDoubleClick={() => this.previewFile(item)}
                                        >
                                          <img className="item-image" src={_url} alt={_alt} />
                                          <div
                                            className="id-container"
                                            onMouseEnter={() => this.setDragDisabledID(item.asset_id)}
                                            onMouseLeave={() => this.setDragDisabledID(undefined)}
                                          >
                                            {item.asset_id}
                                          </div>
                                        </div>
                                      </div>
                                      {!snapshot.isDragging && (
                                        <CustomFormItem
                                          label={t("PropertyMedia.altLabel", { title: `Image ${index + 1}` })}
                                          name={["media", MEDIA_TYPES.GALLERY, index, "alt_text"]}
                                          rules={[
                                            {
                                              required: true,
                                              max: 100,
                                              message: t("ErrorMessages.ImageDescriptionMessage"),
                                            },
                                          ]}
                                          className="alt-details"
                                        >
                                          <Input />
                                        </CustomFormItem>
                                      )}
                                    </div>
                                  )}
                                </Draggable>
                              );
                            })}
                            {provided1.placeholder}
                          </div>
                        )}
                      </Droppable>
                    </div>
                    {/* ------------------------------ */}
                  </div>
                </Col>
              </Row>
            </Col>
            <Col xs={24} sm={24} md={24} lg={10} className="pad-0">
              <div className="property-media__all-container droppable-container">
                <h5 className="text-center mg-bottom-10">{t("PropertyMedia.Image&PDFLibrary")}</h5>
                <p className="text-center mg-bottom-0">{t("PropertyMedia.DragandDrop")}</p>
                <small className="mg-bottom-5 font-bold text-center">{t("PropertyMedia.DoubleClick")}</small>
                <div className="filter-buttons">
                  <Button
                    type={this.state.category.image ? "primary" : "default"}
                    size="small"
                    className="mg-right-20"
                    onClick={() => this.onChangeCategory("image")}
                  >
                    {t("PropertyMedia.Image")}
                  </Button>
                  <Button
                    type={this.state.category.pdf ? "primary" : "default"}
                    size="small"
                    onClick={() => this.onChangeCategory("pdf")}
                  >
                    {t("PropertyMedia.PDF")}
                  </Button>
                </div>
                <Droppable droppableId="all" direction="horizontal" isDropDisabled={this.state.isSectionDisabled.all}>
                  {(provided1, snapshot1) => (
                    <div ref={provided1.innerRef} style={getMainListStyle(snapshot1.isDraggingOver)}>
                      <PlaceHolder loading={this.props.loading}>
                        {filteredImages.length
                          ? filteredImages.map((item, index) => {
                              const _url = `${item.thumbnails_webimage_url}?ver=${RANDOM}`;
                              const _alt = item.asset_name;

                              const isPDF = isPDFFileType(item || item.thumbnails_webimage_url);
                              const _style = {};

                              return (
                                <Draggable
                                  key={item.asset_id}
                                  draggableId={item.asset_id}
                                  index={index}
                                  isDragDisabled={viewOnlyMode || dragDisabledID === item.asset_id}
                                >
                                  {(provided, snapshot) => (
                                    <div
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                      className="property-media-all__item"
                                      style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
                                    >
                                      <div
                                        onDoubleClick={() => this.previewFile(item)}
                                        className="property-media-all__item-hover"
                                      >
                                        <img
                                          className={`item-image ${isPDF ? "pdf" : ""}`}
                                          src={_url}
                                          alt={_alt}
                                          style={{
                                            // objectFit: "fill",
                                            ..._style,
                                          }}
                                        />

                                        <div
                                          className="id-container text-center label-hover"
                                          style={
                                            {
                                              /* height: "20%" */
                                            }
                                          }
                                          onMouseEnter={() => this.setDragDisabledID(item.asset_id)}
                                          onMouseLeave={() => this.setDragDisabledID(undefined)}
                                        >
                                          {item.asset_id}
                                          <PDFIcon item={item} isPDF={isPDF} />
                                        </div>
                                        {/* <div className="text-center">{item.name}</div> */}
                                      </div>
                                    </div>
                                  )}
                                </Draggable>
                              );
                            })
                          : this._renderMessage()}
                      </PlaceHolder>
                      {provided1.placeholder}
                    </div>
                  )}
                </Droppable>
              </div>
            </Col>
          </Row>
        </DragDropContext>
        <AppModal
          className="media-preview"
          title="File Preview"
          width="80%"
          visible={this.state.isModalOpen}
          onCancel={() => {
            this.toggleModal(false);
          }}
          maxHeight="100vh"
          overFlowY="auto"
          footer={null}
          destroyOnClose
        >
          <FilePreview file={this.state.previewItem} />
        </AppModal>
      </>
    );
  }
}

PropertyMediaContainer.propTypes = {
  marketingCollateralLabel: PropTypes.string,
  selectedMedia: PropTypes.object,
  translatedSelectedMedia: PropTypes.object,
  updateFiles: PropTypes.func,
  propertyMedia: PropTypes.array,
  mediaErrors: PropTypes.object,
  isEditView: PropTypes.bool,
  viewOnlyMode: PropTypes.bool,
  selectedPropertyCode: PropTypes.string,
  loading: PropTypes.bool,
  helperText: PropTypes.object,
  t: PropTypes.func,
  language: PropTypes.object,
  languageStatus: PropTypes.string,
  form: PropTypes.object,
  auditPanelDrawerVisible: PropTypes.bool,
  propertyType: PropTypes.string,
  isDynamicMediaAssetsEnabled: PropTypes.bool,
};

PropertyMediaContainer.defaultProps = {
  propertyMedia: [],
  selectedMedia: {},
  isDynamicMediaAssetsEnabled: false,
};

PlaceHolder.propTypes = {
  loading: PropTypes.bool,
  children: PropTypes.any,
  cols: PropTypes.number,
};

PlaceHolder.defaultProps = {
  cols: 3,
};

export default withTranslation()(PropertyMediaContainer);
